import { render, staticRenderFns } from "./recordsORjournal.vue?vue&type=template&id=3b89a2d8&"
import script from "./recordsORjournal.vue?vue&type=script&lang=js&"
export * from "./recordsORjournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports